/**
 * @generated SignedSource<<50bd90f9f2badc740ce6cbd11954da44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackageModal_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageAuth_session" | "StorePackageDetailFooter_session">;
  readonly " $fragmentType": "StorePackageModal_session";
};
export type StorePackageModal_session$key = {
  readonly " $data"?: StorePackageModal_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageModal_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageDetailFooter_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageAuth_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "8c13af10a40cdd8ce2d4778089031d4a";

export default node;
